import React, { useState, useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { fetchBlogDetails, fetchRecentBlogs, searchBlogs } from "../Adapter/PageAdapter";
import SeoHelmet from "../components/SeoHelmet";
import { baseImage_path } from "../variables/Variables";
import BannerImg from "../assets/images/Blogs.jpg";
import SearchBlk from "../assets/images/spciallites/searchblk.png";
import { Helmet } from "react-helmet-async";
import { stripHtmlForMeta } from "../utils/seoMetaText";


const BlogDetails = () => {

    // const { id } = useParams();
    const [blog, setBlog] = useState(null);
    const [bannerData, setBannerData] = useState([]);
    const [loading, setLoading] = useState(true);
    const [blogs, setBlogs] = useState([]);
    const [recentBlogs, setRecentBlogs] = useState([]);
    const [searchInput, setSearchInput] = useState("");
    const navigate = useNavigate();
    const { slug } = useParams();

    useEffect(() => {
        const fetchDetails = async () => {
            setLoading(true);
            try {
                // Load by the slug in the URL so direct links, refreshes and Google work
                const response = await fetchBlogDetails(slug);
                if (response && response.status === "success" && response.data) {
                    setBlog(response.data);
                } else {
                    setBlog(null);
                    console.error("Blog not found.");
                }
            } catch (error) {
                setBlog(null);
                console.error("Error fetching blog details:", error);
            } finally {
                setLoading(false);
            }
        };

        fetchDetails();
    }, [slug]);

    useEffect(() => {
        const fetchData = async () => {
            try {
                const recentResponse = await fetchRecentBlogs();
                if (recentResponse && recentResponse.data) {
                    setRecentBlogs(recentResponse.data);
                }
            } catch (error) {
                console.error("Error fetching blogs data:", error);
            }
        };

        fetchData();
    }, []);

    // ✅ Dynamically inject and execute custom script (same as SeoSpecialityHelmet)
    useEffect(() => {
        if (!blog?.custom_scripts) return;

        const decodeHtmlEntities = (html) => {
            const textarea = document.createElement("textarea");
            textarea.innerHTML = html;
            return textarea.value;
        };

        let decoded = decodeHtmlEntities(blog.custom_scripts).trim();
        const match = decoded.match(
            /<script[^>]*type=["']?(.*?)["']?[^>]*>([\s\S]*?)<\/script>/i
        );

        let type = "text/javascript";
        let content = decoded;

        if (match) {
            type = match[1] || "text/javascript";
            content = match[2].trim();
        }

        const isJsonLd =
            type === "application/ld+json" ||
            (content.trim().startsWith("{") && content.trim().endsWith("}"));

        if (isJsonLd) {
            try {
                JSON.parse(content);
                type = "application/ld+json";
            } catch (err) {
                console.error("Invalid JSON-LD", err);
                return;
            }
        }

        const script = document.createElement("script");
        script.id = "seo-script";
        script.type = type;
        script.text = content;

        const existing = document.getElementById("seo-script");
        if (existing) existing.remove();

        document.head.appendChild(script);

        return () => {
            const scriptToRemove = document.getElementById("seo-script");
            if (scriptToRemove) scriptToRemove.remove();
        };
    }, [blog?.custom_scripts]);

    // Trigger search automatically when input changes
    useEffect(() => {
        const fetchSearchResults = async () => {
            if (!searchInput.trim()) {
                // If search input is empty, reset to recent blogs
                const recentResponse = await fetchRecentBlogs();
                if (recentResponse && recentResponse.data) {
                    setRecentBlogs(recentResponse.data);
                }
                return;
            }

            try {
                const searchResponse = await searchBlogs({ title: searchInput.trim() });
                if (searchResponse && searchResponse.data) {
                    setRecentBlogs(searchResponse.data); // Display search results in Recent Posts
                } else {
                    setRecentBlogs([]); // Show empty state if no results
                }
            } catch (error) {
                console.error("Error searching blogs:", error);
            }
        };

        fetchSearchResults();
    }, [searchInput]); // Runs whenever searchInput changes

    // Handle search functionality
    const handleSearch = async (e) => {
        e.preventDefault();
        if (!searchInput.trim()) return;

        try {
            const searchResponse = await searchBlogs({ title: searchInput.trim() });
            if (searchResponse && searchResponse.data) {
                setRecentBlogs(searchResponse.data); // Show search results in Recent Posts
            } else {
                setRecentBlogs([]); // Clear if no results
            }
        } catch (error) {
            console.error("Error searching blogs:", error);
        }
    };

    const handleReadMore = (slug) => {
        navigate(`/blogs/${slug}`);
    };

    if (loading) {
        return <p>Loading blog details...</p>;
    }

    if (!blog) {
        return <p>Blog not found.</p>;
    }

    return (
        <>
            {blog && <Helmet>
                <title>{blog?.meta_title}</title>
                <meta name="description" content={stripHtmlForMeta(blog?.meta_description)} />
            </Helmet>}
            {/* Bannner Section */}
            <section className="banner-spac">
                <div className="cust-container">
                    <div className="banner-box">
                        {bannerData && bannerData.banner_img ? (
                            <img
                                src={`${baseImage_path}${bannerData.banner_img.replace(/^\.\//, "")}`}
                                alt={bannerData.title || "Blogs"}
                            />
                        ) : (
                            <img src={BannerImg} alt="Blogs Fallback" />
                        )}
                        <div className="ban-con">
                            <h1>{blog.title}</h1>
                        </div>
                    </div>
                </div>
            </section>

            {/* paragraph section */}
            <section className="jobdescriptionsec">
                <div className="cust-container">
                    <div className="jobdescription-inner">
                        <div className="row">
                            <div className="col-xl-8 col-lg-8 col-md-12 col-sm-12 col-12 mb-4">
                                <div className="host-det blog-detail-desc mobtopmarg uldisc">
                                    {/* <h4>{blog.title}</h4> */}
                                    <div className="CenterBlog" style={{ h2: 'font-size: calc(1rem + .9vw)' }}>
                                        {/* <div className="blog-category">
                                            <span>{blog.category || "Uncategorized"}</span>
                                        </div> */}
                                        <div className="blog-image">
                                            <img
                                                src={`${baseImage_path}/${blog.featured_img || "images/blogs/blog.jpeg"}`}
                                                alt={blog.title}
                                            />
                                        </div>
                                    </div>
                                    {/* <p>{blog.content || "No content available for this blog."}</p> */}
                                    {/* <p dangerouslySetInnerHTML={{ __html: blog.content }} /> */}
                                    <div className="ck-content" dangerouslySetInnerHTML={{ __html: blog.content }} />
                                </div>
                            </div>
                            <div className="col-xl-4 col-lg-4 col-md-12 col-sm-12 col-12 mb-4">
                                <div className="blog-right-panel">
                                    <div className="specialty-search width100">
                                        <form className="example" onSubmit={handleSearch}>
                                            <input
                                                type="text"
                                                placeholder="Search by Title"
                                                value={searchInput}
                                                onChange={(e) => setSearchInput(e.target.value)}
                                            />
                                            <button type="submit">
                                                <img src={SearchBlk} alt="Search" />
                                            </button>
                                        </form>
                                    </div>
                                    <div className="blog-recent-items">
                                        <h5>Recent Posts</h5>
                                        {recentBlogs.slice(0, 10).map((post) => (
                                            <div key={post.id} className="our-video-sec-item blog-rece-item">
                                                <div className="our-video-img">
                                                    <img
                                                        src={`${baseImage_path}/${post.featured_img || "default-blog.jpg"}`}
                                                        alt={post.title}
                                                    />
                                                </div>
                                                <div className="our-video-desc our-vdo-desc-cta-green">
                                                    <p>{post.title}</p>
                                                    <a href="#" onClick={() => handleReadMore(post.slug)}>Read More</a>
                                                </div>
                                            </div>
                                        ))}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </>
    );
};

export default BlogDetails;